export { default } from './CollectionCards';
export type {
  IPrismicCollectionCardsItem,
  IPrismicCollectionCardsPrimary,
} from './types';
